import { render } from "./PaginationArray.vue?vue&type=template&id=84741a0e&scoped=true"
import script from "./PaginationArray.vue?vue&type=script&lang=js"
export * from "./PaginationArray.vue?vue&type=script&lang=js"

import "./PaginationArray.vue?vue&type=style&index=0&id=84741a0e&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84741a0e"]])

export default __exports__